// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : tree react-hooks
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { get, dict, size, mapItems, sorted } from 'ldash';
import log from 'uix/logging';
import { useApi, useMemo } from 'uix/hooks';
import { normalize } from 'uix/normalize';
// ---Local imports
// ---Exports
export const useTopstructures = ({ otid })=>{
    let result = null;
    // XXX - persist in redux store
    let { data, error } = useApi('getTopstructures', {
        otid
    }, {
        cached: true
    });
    let normalized_data = useMemo(()=>{
        let res = data;
        if (data && data.rows) {
            let byId = {};
            let byParentId = {};
            let rows = normalize(data.rows);
            for (let r of rows){
                byId[r.otid] = r;
                if (!byParentId[r.otparent]) {
                    byParentId[r.otparent] = [];
                }
                byParentId[r.otparent].push(r);
            }
            byParentId = dict(mapItems(byParentId, (otid, rows)=>[
                    otid,
                    sorted(rows, (r)=>r.sort)
                ]));
            let rootLevel = byParentId[otid] || [];
            res = {
                ...res,
                rows,
                byId,
                byParentId,
                rootLevel
            };
        }
        return res;
    }, [
        data
    ]);
    if (data) {
        result = normalized_data;
    } else if (error) {
        log.warn('error during retrieving topstructs');
    }
    return result;
};
